import { useState, useCallback } from "react"
import type { Toast } from "@/clientWeb/components/ui/toast"

let toastId = 0

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([])

  const showToast = useCallback((message: string, senderName?: string, duration?: number) => {
    const id = `toast-${++toastId}`
    const toast: Toast = { id, message, senderName, duration }
    setToasts((prev) => [...prev, toast])
    return id
  }, [])

  const dismissToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }, [])

  const clearToasts = useCallback(() => setToasts([]), [])

  return { toasts, showToast, dismissToast, clearToasts }
}
